import { mapGetters, mapMutations, mapActions } from 'vuex';
import format from '@/common/utilities/format';
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtInputRange from '@/common/components/mvtinputrange/mvt-inputrange.vue';
import mvtRange from '@/common/components/mvtrange/mvt-range.vue';
import mvtSelect from '@/common/components/mvtselect/mvt-select.vue';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import mvtSelectRange from '@/common/components/mvtselectrange/mvt-selectrange.vue';
import mvtAutocompleteTag from '@/common/components/mvtautocompletetag/mvt-autocompletetag.vue';
import { openOverlayer, closeOverlayer } from '../../utilities/nojq/_overlayer.js';
import { generateFilterLabel, getIconLabel as sharedGetIconLabel, getFormatValue as sharedGetFormatValue, isChanged as sharedIsChanged, getLabel as sharedGetLabel } from '@/common/utilities/mvtsearchfilter/generateFilterLabel.js';
const priceData = [
    {
        text: '$100K',
        value: 100000,
    },
    {
        text: '$125K',
        value: 125000,
    },
    {
        text: '$150K',
        value: 150000,
    },
    {
        text: '$175K',
        value: 175000,
    },
    {
        text: '$200K',
        value: 200000,
    },
    {
        text: '$225K',
        value: 225000,
    },
    {
        text: '$250K',
        value: 250000,
    },
    {
        text: '$275K',
        value: 275000,
    },
    {
        text: '$300K',
        value: 300000,
    },
    {
        text: '$325K',
        value: 325000,
    },
    {
        text: '$350K',
        value: 350000,
    },
    {
        text: '$375K',
        value: 375000,
    },
    {
        text: '$400K',
        value: 400000,
    },
    {
        text: '$450K',
        value: 450000,
    },
    {
        text: '$500K',
        value: 500000,
    },
    {
        text: '$550K',
        value: 550000,
    },
    {
        text: '$600K',
        value: 600000,
    },
    {
        text: '$650K',
        value: 650000,
    },
    {
        text: '$700K',
        value: 700000,
    },
    {
        text: '$800K',
        value: 800000,
    },
    {
        text: '$900K',
        value: 900000,
    },
    {
        text: '$1M',
        value: 1000000,
    },
    {
        text: '$1.25M',
        value: 1250000,
    },
    {
        text: '$1.5M',
        value: 1500000,
    },
    {
        text: '$1.75M',
        value: 1750000,
    },
    {
        text: '$2M',
        value: 2000000,
    },
    {
        text: '$2.25M',
        value: 2250000,
    },
    {
        text: '$2.5M',
        value: 2500000,
    },
    {
        text: '$2.75M',
        value: 2750000,
    },
    {
        text: '$3M',
        value: 3000000,
    },
    {
        text: '$4M',
        value: 4000000,
    },
    {
        text: '$5M',
        value: 5000000,
    },
    {
        text: '$6M',
        value: 6000000,
    },
    {
        text: '$7M',
        value: 7000000,
    },
    {
        text: '$8M',
        value: 8000000,
    },
    {
        text: '$9M',
        value: 9000000,
    },
    {
        text: '$10M',
        value: 10000000,
    },
];
const priceDataRent = [
    {
        text: '$100',
        value: 100,
    },
    {
        text: '$200',
        value: 200,
    },
    {
        text: '$300',
        value: 300,
    },
    {
        text: '$400',
        value: 400,
    },
    {
        text: '$500',
        value: 500,
    },
    {
        text: '$600',
        value: 600,
    },
    {
        text: '$700',
        value: 700,
    },
    {
        text: '$800',
        value: 800,
    },
    {
        text: '$900',
        value: 900,
    },
    {
        text: '$1000',
        value: 1000,
    },
    {
        text: '$1100',
        value: 1100,
    },
    {
        text: '$1200',
        value: 1200,
    },
    {
        text: '$1300',
        value: 1300,
    },
    {
        text: '$1400',
        value: 1400,
    },
    {
        text: '$1500',
        value: 1500,
    },
    {
        text: '$1600',
        value: 1600,
    },
    {
        text: '$1700',
        value: 1700,
    },
    {
        text: '$1800',
        value: 1800,
    },
    {
        text: '$1900',
        value: 1900,
    },
    {
        text: '$2000',
        value: 2000,
    },
    {
        text: '$2200',
        value: 2200,
    },
    {
        text: '$2400',
        value: 2400,
    },
    {
        text: '$2600',
        value: 2600,
    },
    {
        text: '$2800',
        value: 2800,
    },
    {
        text: '$3000',
        value: 3000,
    },
    {
        text: '$3200',
        value: 3200,
    },
    {
        text: '$3400',
        value: 3400,
    },
    {
        text: '$3600',
        value: 3600,
    },
    {
        text: '$3800',
        value: 3800,
    },
    {
        text: '$4000',
        value: 4000,
    },
    {
        text: '$4200',
        value: 4200,
    },
    {
        text: '$4400',
        value: 4400,
    },
    {
        text: '$4600',
        value: 4600,
    },
    {
        text: '$4800',
        value: 4800,
    },
    {
        text: '$5000',
        value: 5000,
    },
];
export default {
    name: 'mvtSearchFilter',
    inject: ['$eventBus'],
    emits: ["changed"],
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['msp']),
        filterModel() {
            var that = this;
            return {
                set price(val) {
                    that._updateFilter(val);
                },
                get price() {
                    return {
                        minPrice: that.filter.minPrice,
                        maxPrice: that.filter.maxPrice,
                    };
                },
                get ojoAttribute() {
                    return that.filter.ojoAttribute;
                },
                set ojoAttribute(val) {
                    that._updateFilterByKey(val, 'ojoAttribute');
                },

                set houseSize(val) {
                    that._updateFilter(val);
                },
                get houseSize() {
                    return {
                        minHouseSize: that.filter.minHouseSize,
                        maxHouseSize: that.filter.maxHouseSize,
                    };
                },
                set lotSize(val) {
                    that._updateFilter(val);
                },
                get lotSize() {
                    return {
                        minLotSize: that.filter.minLotSize,
                        maxLotSize: that.filter.maxLotSize,
                    };
                },
                set yearBuild(val) {
                    that._updateFilter(val);
                },
                get yearBuild() {
                    return {
                        minYearBuild: that.filter.minYearBuild,
                        maxYearBuild: that.filter.maxYearBuild,
                    };
                },
                set dom(val) {
                    that._updateFilter(val);
                },
                get dom() {
                    return { minDOM: that.filter.minDOM, maxDOM: that.filter.maxDOM };
                },
                set hoa(val) {
                    that._updateFilter(val);
                },
                get hoa() {
                    return { minHoa: that.filter.minHoa, maxHoa: that.filter.maxHoa };
                },
                get bed() {
                    return [that.filter.minBed, that.filter.maxBed];
                },
                set bed(val) {
                    that._updateFilterByKey(val[0], 'minBed');
                    that._updateFilterByKey(val[1], 'maxBed');
                },
                get bath() {
                    return [that.filter.minBath, that.filter.maxBath];
                },
                set bath(val) {
                    that._updateFilterByKey(val[0], 'minBath');
                    that._updateFilterByKey(val[1], 'maxBath');
                },
                set soldDateRange(val) {
                    let from = that.isRent ? 'RENT' : that.isSold ? 'SOLD' : 'SALE';
                    let to = val ? 'SOLD' : 'SALE';
                    let params = that.getInitalFilter(from, to);
                    params['soldDateRange'] = val;
                    that._updateFilter(params);
                },
                get soldDateRange() {
                    return that.filter.soldDateRange;
                },
                set propertyType(val) {
                    that._updateFilterByKey(val, 'propertyType');
                },
                get propertyType() {
                    return that.filter.propertyType;
                },
                set updateNew(val) {
                    that._updateFilterByKey(val, 'updateNew');
                },
                get updateNew() {
                    return that.filter.updateNew;
                },
                set openHouse(val) {
                    that._updateFilterByKey(val, 'propertyCriteriaOpenHouse');
                },
                get openHouse() {
                    return that.filter.propertyCriteriaOpenHouse;
                },
                set virtualTour(val) {
                    that._updateFilterByKey(val, 'updateVirtualTour');
                },
                get virtualTour() {
                    return that.filter.updateVirtualTour;
                },
                set newConstruction(val) {
                    that._updateFilterByKey(val, 'updateNewConstruction');
                },
                get newConstruction() {
                    return that.filter.updateNewConstruction;
                },
                set foreclosed(val) {
                    that._updateFilterByKey(val, 'propertyCriteriaForeclosed');
                },
                get foreclosed() {
                    return that.filter.propertyCriteriaForeclosed;
                },
                set hidePending(val) {
                    that._updateFilterByKey(val, 'hidePending');
                },
                get hidePending() {
                    return that.filter.hidePending;
                },
                set photos(val) {
                    that._updateFilterByKey(val, 'photos');
                },
                get photos() {
                    return that.filter.photos;
                },
                set minHouseSize(val) {
                    that._updateFilterByKey(val, 'minHouseSize');
                },
                get minHouseSize() {
                    return that.filter.minHouseSize;
                },
                set maxHouseSize(val) {
                    that._updateFilterByKey(val, 'maxHouseSize');
                },
                get maxHouseSize() {
                    return that.filter.maxHouseSize;
                },
                set minLotSize(val) {
                    that._updateFilterByKey(val, 'minLotSize');
                },
                get minLotSize() {
                    return that.filter.minLotSize;
                },
                set maxLotSize(val) {
                    that._updateFilterByKey(val, 'maxLotSize');
                },
                get maxLotSize() {
                    return that.filter.maxLotSize;
                },
                set minYearBuild(val) {
                    that._updateFilterByKey(val, 'minYearBuild');
                },
                get minYearBuild() {
                    return that.filter.minYearBuild;
                },
                set maxYearBuild(val) {
                    that._updateFilterByKey(val, 'maxYearBuild');
                },
                get maxYearBuild() {
                    return that.filter.maxYearBuild;
                },
                set minDOM(val) {
                    that._updateFilterByKey(val, 'minDOM');
                },
                get minDOM() {
                    return that.filter.minDOM;
                },
                set maxDOM(val) {
                    that._updateFilterByKey(val, 'maxDOM');
                },
                get maxDOM() {
                    return that.filter.maxDOM;
                },
                set minHoa(val) {
                    that._updateFilterByKey(val, 'minHoa');
                },
                get minHoa() {
                    return that.filter.minHoa;
                },
                set maxHoa(val) {
                    that._updateFilterByKey(val, 'maxHoa');
                },
                get maxHoa() {
                    return that.filter.maxHoa;
                },
                set isPriceReduced(val) {
                    that._updateFilterByKey(val, 'updatePriceReduced');
                },
                get isPriceReduced() {
                    return that.filter.updatePriceReduced;
                },
                set houseStates(val) {
                    var rentals = val.indexOf('rentals') > -1 ? 1 : 0;
                    if (that.filter.rentals != rentals) {
                        let from = that.isRent ? 'RENT' : that.isSold ? 'SOLD' : 'SALE';
                        let to = rentals ? 'RENT' : 'SALE';
                        let params = that.getInitalFilter(from, to);
                        that._updateFilter(params);
                    } else {
                        var openHouse = val.indexOf('openHouse') > -1 ? 1 : 0;
                        if (that.filter.propertyCriteriaOpenHouse != openHouse) {
                            that._updateFilterByKey(openHouse, 'propertyCriteriaOpenHouse');
                        }
                        var virtualTour = val.indexOf('virtualTour') > -1 ? 1 : 0;
                        if (that.filter.updateVirtualTour != virtualTour) {
                            that._updateFilterByKey(virtualTour, 'updateVirtualTour');
                        }
                        var newConstruction = val.indexOf('newConstruction') > -1 ? 1 : 0;
                        if (that.filter.updateNewConstruction != newConstruction) {
                            that._updateFilterByKey(newConstruction, 'updateNewConstruction');
                        }
                        var newest = val.indexOf('newest') > -1 ? 1 : 0;
                        if (that.filter.updateNew != newest) {
                            that._updateFilterByKey(newest, 'updateNew');
                        }
                        var priceReduced = val.indexOf('priceReduced') > -1 ? 1 : 0;
                        if (that.filter.updatePriceReduced != priceReduced) {
                            that._updateFilterByKey(priceReduced, 'updatePriceReduced');
                        }
                        var foreclosed = val.indexOf('foreclosed') > -1 ? 1 : 0;;
                        if (that.filter.propertyCriteriaForeclosed != foreclosed) {
                            that._updateFilterByKey(foreclosed, 'propertyCriteriaForeclosed');
                        }
                        var pending = val.indexOf('hidePending') > -1 ? 1 : 0;
                        if (that.filter.hidePending != pending) {
                            that._updateFilterByKey(pending, 'hidePending');
                        }
                        var photos = val.indexOf('photos') > -1 ? 1 : 0;
                        if (that.filter.photos != photos) {
                            that._updateFilterByKey(photos, 'photos');
                        }

                        //if pool or garage, add into ojoAttributes
                        var pool = val.indexOf('pool') > -1 ? 1 : 0;
                        var garage = val.indexOf('garage') > -1 ? 1 : 0;
                        var ojoAttr = that.filter.ojoAttribute;
                        var changed = false;
                        if (!garage && ojoAttr.indexOf('garage') > -1) {
                            ojoAttr.splice(ojoAttr.indexOf('garage'), 1);
                            changed = true;
                        } else if (garage && ojoAttr.indexOf('garage') == -1) {
                            ojoAttr.push('garage');
                            changed = true;
                        }
                        if (!pool && ojoAttr.indexOf('pool') > -1) {
                            ojoAttr.splice(ojoAttr.indexOf('pool'), 1);
                            changed = true;
                        } else if (pool && ojoAttr.indexOf('pool') == -1) {
                            ojoAttr.push('pool');
                            changed = true;
                        }
                        if (changed) {
                            that._updateFilterByKey(ojoAttr, 'ojoAttribute');
                        }

                        if (openHouse || newest || priceReduced || pending || foreclosed) {
                            that._updateFilterByKey(true, 'isActive');
                        }
                    }
                },
                get houseStates() {
                    var result = [];
                    if (that.filter.propertyCriteriaOpenHouse) {
                        result.push('openHouse');
                    }
                    if (that.filter.updateNew) {
                        result.push('newest');
                    }
                    if (that.filter.updatePriceReduced) {
                        result.push('priceReduced');
                    }
                    if (that.filter.updateVirtualTour) {
                        result.push('virtualTour');
                    }
                    if (that.filter.updateNewConstruction) {
                        result.push('newConstruction');
                    }
                    if (that.filter.hidePending) {
                        result.push('hidePending');
                    }
                    if (that.filter.propertyCriteriaForeclosed) {
                        result.push('foreclosed');
                    }
                    if (that.filter.photos) {
                        result.push('photos');
                    }
                    if (that.filter.rentals) {
                        result.push('rentals');
                    }
                    if (that.filter.ojoAttribute) {
                        //if include pool or garage
                        if (that.filter.ojoAttribute.indexOf('pool') > -1) {
                            result.push('pool');
                        }
                        if (that.filter.ojoAttribute.indexOf('garage') > -1) {
                            result.push('garage');
                        }
                    }
                    return result;
                },
            };
        },
        isSale() {
            return !this.isRent && !this.isSold;
        },
        isRent() {
            return this.filter.rentals;
        },
        isSold() {
            return this.filter.soldDateRange;
        },
        filter() {
            return this.modelValue;
        },
        isFocusMode() {
            return this.focusIds && this.focusIds.length > 0;
        },

        filterLabel() {
            return generateFilterLabel({
                searchFilterData: this.searchFilterData,
                filterModel: this.filterModel,
                filterValue: this.filter,
                isRent: this.isRent,
                isSold: this.isSold,
                molang: this.molang,
            });
        },
        hasPrice() {
            return this.filter.minPrice || this.filter.maxPrice;
        },
        hasPropertyType() {
            return this.filter.propertyType.length > 0;
        },
        hasBed() {
            return this.filter.minBed || this.filter.maxBed;
        },
        hasBath() {
            return this.bath.minBath || this.bath.maxBath;
        },
        hasHouseSize() {
            return this.filter.minHouseSize || this.filter.maxHouseSize;
        },
        hasLostSize() {
            return this.filter.minLotSize || this.filter.maxLotSize;
        },
    },
    methods: {
        ...mapActions('glb', ['getFavoriteListings']),
        getIconLabel(label, changed, icon) {
            return sharedGetIconLabel(label, changed, icon);
        },
        getLabel(value, defaultValue, changed, filter) {
            return sharedGetLabel(value, defaultValue, changed, filter);
        },
        getFormatValue(value, input, isEndWithPlus) {
            return sharedGetFormatValue(value, input, isEndWithPlus, this.molang);
        },
        isChanged(value, defaultValue) {
            return sharedIsChanged(value, defaultValue);
        },
        getTitle(item) {
            return typeof item.title === 'function' ? item.title() : item.title
        },
        updatePriceRange(isRent) {
            this.searchFilterData.find((filter) => filter.id === 'price').data = isRent ? priceDataRent : priceData;
        },
        resetPosition(target) {
            if (!target || !this.$refs.searchFilter) {
                return;
            }
            let winWidth = window.innerWidth;
            let height = target.clientHeight;
            let offset = target.getBoundingClientRect();
            let $el = this.$refs.searchFilter;
            let listWidth = getComputedStyle($el).width.replace('px', '') * 1;
            let left = offset.left;
            let top = offset.top + height + 10;
            if (left + listWidth > winWidth) {
                left = offset.left - (offset.left + listWidth - winWidth);
            }

            $el.style.left = left + 'px';
            $el.style.top = top + 'px';
        },
        saveSearch() {
            this.close();
            this.$eventBus.$emit('eventbus-save-search', { trigger: this.$options.name });
        },
        reset(ids) {
            if (ids && ids.indexOf('-') > -1) {
                let dict = ids.split('-');
                let id = dict[0];
                let filter = this.searchFilterData.find((e) => {
                    return e.id === id;
                });
                let key = filter.model;
                let value = dict[1];
                if (Array.isArray(this.filterModel[key])) {
                    //remove value from this.filterModel[key]
                    this.filterModel[key] = this.filterModel[key].filter((item) => item != value);
                } else {
                    this.filterModel[key] = 0;
                }
                return;
            }
            let listIds = ids.split('_');
            let filters = this.searchFilterData.filter((e) => {
                return listIds.includes(e.id);
            });
            if (filters && filters.length > 0) {
                filters.forEach((filter) => {
                    let value = this.filterModel[filter.model];
                    let defaultValue = filter.options ? filter.options.defaultValue || '' : '';
                    if (defaultValue && defaultValue.length === 2) {
                        if (filter.options && filter.options.mapping) {
                            this.filterModel[filter.model] = {
                                [filter.options.mapping.min]: defaultValue[0],
                                [filter.options.mapping.max]: defaultValue[1],
                            };
                        } else {
                            this.filterModel[filter.model] = defaultValue;
                        }
                    } else if (Array.isArray(value) && value.length > 0) {
                        //filter value which in filter.data
                        if (filter.data && filter.data.length > 0) {
                            this.filterModel[filter.model] = value.filter((item) => {
                                return !filter.data.find((e) => (e.value || e) === item);
                            });
                        } else {
                            this.filterModel[filter.model] = [];
                        }
                    } else {
                        this.filterModel[filter.model] = defaultValue;
                    }
                });
            }
        },
        open(target, ids) {
            if (this.isActive) {
                return;
            }
            if (ids && this.wideCase.includes(ids)) {
                this.wide = true;
            } else {
                this.wide = false;
            }
            if (ids && ids.indexOf('-') > -1) {
                let dict = ids.split('-');
                let id = dict[0];
                let filter = this.searchFilterData.find((e) => {
                    return e.id === id;
                });
                let key = filter.model;
                let value = dict[1];
                if (Array.isArray(this.filterModel[key])) {
                    //add into this.filterModel[key]
                    if (this.filterModel[key].indexOf(value) == -1) {
                        let list = this.filterModel[key];
                        list.push(value);
                        this.filterModel[key] = list;
                    }
                } else {
                    this.filterModel[key] = value;
                }
                return;
            }
            if (ids && ids.includes('#')) {
                this.focusIds = [ids];
            } else if (ids) {
                this.focusIds = ids.split('_');
            } else {
                this.focusIds = [];
            }

            this.isActive = true;
            this.$nextTick(() => {
                if (ids && ids.includes('#')) {
                    this.$refs.searchFilter?.querySelector('.hidden-default.focused')?.classList.remove('focused');
                    this.$refs.searchFilter?.querySelector(ids)?.classList.add('focused');
                }
                if (typeof window !== 'undefined' && window.innerWidth >= this.glb.viewport.xsScreen[1]) {
                    this.resetPosition(target);
                }
                document.getElementById('body')?.classList.add('mvt-searchfilter-open');
                openOverlayer('searchfilter-active');
            });
        },
        close() {
            if (!this.isActive) {
                return;
            }
            this.$refs.searchFilter?.querySelector('.hidden-default.focused')?.classList.remove('focused');
            document.getElementById('body')?.classList.remove('mvt-searchfilter-open');
            closeOverlayer('searchfilter-active');
            this.isActive = false;
            this.$eventBus.$emit('eventbus-searchfilter-close');
        },
        toggle() {
            if (this.isActive) {
                this.close();
            } else {
                this.open();
            }
        },
        switchIndex(value) {
            if (value === 2) {
                this.filterModel.soldDateRange = 'all';
            } else if (value === 1) {
                this.filterModel.houseStates = ['rentals'];
            } else {
                this.filterModel.soldDateRange = '';
            }
        },
        getInitalFilter(from, to) {
            let params = {};
            if (from && to) {
                if (from === 'RENT') {
                    params.maxPrice = 0;
                    params.minPrice = 0;
                } else if (from === 'SOLD') {
                    params.soldDateRange = 0;
                }

                if (to === 'RENT') {
                    params.rentals = 1;
                } else {
                    params.rentals = 0;
                }

                if (to === 'RENT') {
                    params.ojoAttribute = [];
                    params.minPrice = 0;
                    params.maxPrice = 0;
                    params.rentals = 1;
                    let propertyTypes = [...this.filter.propertyType];
                    //remove 'land' 'multi-family' 'mobile' from array propertyTypes if exist
                    if (propertyTypes.indexOf('land') > -1) {
                        propertyTypes.splice(propertyTypes.indexOf('land'), 1);
                    }
                    if (propertyTypes.indexOf('multi-family') > -1) {
                        propertyTypes.splice(propertyTypes.indexOf('multi-family'), 1);
                    }
                    if (propertyTypes.indexOf('mobile') > -1) {
                        propertyTypes.splice(propertyTypes.indexOf('mobile'), 1);
                    }
                    params.propertyType = propertyTypes;
                    params.minHouseSize = 0;
                    params.maxHouseSize = 0;
                    params.minLotSize = 0;
                    params.maxLotSize = 0;
                    params.maxHoa = -1;
                    params.minHoa = -1;
                    params.pool = 0;
                    params.fixerupper = 0;
                    params.isActive = 1;

                    params.propertyCriteriaOpenHouse = 0;
                    params.propertyCriteriaForeclosed = 0;
                    params.updatePriceReduced = 0;
                    params.updateVirtualTour = 0;
                    params.updateNewConstruction = 0;
                    params.propertyListedMovoto = 0;
                    params.hidePending = 0;
                    params.photos = 0;
                    params.garage = 0;
                } else if (to === 'SOLD') {
                    params.propertyCriteriaOpenHouse = 0;
                    params.propertyCriteriaForeclosed = 0;
                    params.updatePriceReduced = 0;
                    params.updateVirtualTour = 0;
                    params.updateNewConstruction = 0;
                    params.hidePending = 0;
                    params.updateNew = 0;
                    params.isActive = false;
                }
                params.propertyCriteriaLuxuryHome = 0;
                params.minDOM = 0;
                params.maxDOM = 0;
                this.updatePriceRange(to === 'RENT');
                return params;
            }
            params = {
                coordinates: null,
                minBed: 0,
                maxBed: 0,
                minBath: 0,
                maxBath: 0,
                soldDateRange: 0,
                minPrice: 0,
                maxPrice: 0,
                propertyType: [],
                minHouseSize: 0,
                maxHouseSize: 0,
                minLotSize: 0,
                maxLotSize: 0,
                minYearBuild: 0,
                maxYearBuild: 0,
                minDOM: 0,
                maxDOM: 0,
                maxHoa: -1,
                minHoa: -1,
                pool: 0,
                isActive: 1,
                updateNew: 0,
                propertyCriteriaOpenHouse: 0,
                updatePriceReduced: 0,
                updateVirtualTour: 0,
                updateNewConstruction: 0,
                propertyCriteriaForeclosed: 0,
                hidePending: 0,
                photos: 0,
                garage: 0,
                sort: null,
                schoolHigh: 0,
                schoolMiddle: 0,
                schoolElementary: 0,
                schoolPre: 0,
                schoolPublic: 0,
                schoolCharter: 0,
                schoolPrivate: 0,
                schoolMinRate: 1,
                schoolIncludeUnrated: 1,
                schoolId: null,
                ojoAttribute: [],
            };
            return params;
        },
        resetFilter: function () {
            let resetFilter = this.getInitalFilter();
            this._updateFilter(resetFilter);
            this.$eventBus.$emit('eventbus-filter-reset');
        },
        _updateFilterByKey(context, key) {
            var param = {};
            param[key] = (context && context.value) || context;
            param && this._updateFilter(param);
        },
        _updateFilter(param) {
            //param
            this.$emit('changed', Object.assign(param));
        },
        applyFilter(param) {
            this.close();
        },
        filterFieldOptions(item) {
            if (item.id === 'tagFilter') {
                const fromMsp = this.msp?.attributes || [];
                const suggestedTags = fromMsp.length ? fromMsp : this.getDefaultTags();
                return {
                    ...item.options,
                    suggestedTags,
                };
            }
            return item.options;
        },
        getDefaultTags() {
            return this.modelValue.rentals ? [] : ['fireplace', 'backyard', 'view', 'corner_lot', 'natural_light', 'porch', 'rv_parking', 'office', 'stone_countertop', 'hardwood_floors'];
        },
    },
    components: {
        mvtCheckbox,
        mvtInputRange,
        mvtRange,
        mvtRadio,
        mvtSelectRange,
        mvtSelect,
        mvtAutocompleteTag,
    },
    data() {
        const sqftUnit = this.molang('search.filter.units.sqft');
        const acreUnit = this.molang('search.filter.units.acre');
        const acresUnit = this.molang('search.filter.units.acres');
        const lotSizeData = [
            {
                text: `1,000 ${sqftUnit}`,
                value: 1000,
            },
            {
                text: `2,000 ${sqftUnit}`,
                value: 2000,
            },
            {
                text: `4,500 ${sqftUnit}`,
                value: 4500,
            },
            {
                text: `6,500 ${sqftUnit}`,
                value: 6500,
            },
            {
                text: `8,000 ${sqftUnit}`,
                value: 8000,
            },
            {
                text: `0.25 ${acresUnit}`,
                value: 10890,
            },
            {
                text: `0.5 ${acresUnit}`,
                value: 21780,
            },
            {
                text: `1 ${acreUnit}`,
                value: 43560,
            },
            {
                text: `2 ${acresUnit}`,
                value: 87120,
            },
            {
                text: `3 ${acresUnit}`,
                value: 130680,
            },
            {
                text: `4 ${acresUnit}`,
                value: 174240,
            },
            {
                text: `5 ${acresUnit}`,
                value: 217800,
            },
            {
                text: `10 ${acresUnit}`,
                value: 435600,
            },
            {
                text: `40 ${acresUnit}`,
                value: 1742400,
            },
            {
                text: `100 ${acresUnit}`,
                value: 4356000,
            },
        ];
        const sqrtFeetData = [
            {
                text: '500',
                value: 500,
            },
            {
                text: '1,000',
                value: 1000,
            },
            {
                text: '1,250',
                value: 1250,
            },
            {
                text: '1,500',
                value: 1500,
            },
            {
                text: '1,750',
                value: 1750,
            },
            {
                text: '2,000',
                value: 2000,
            },
            {
                text: '2,250',
                value: 2250,
            },
            {
                text: '2,500',
                value: 2500,
            },
            {
                text: '2,750',
                value: 2750,
            },
            {
                text: '3,000',
                value: 3000,
            },
            {
                text: '3,500',
                value: 3500,
            },
            {
                text: '4,000',
                value: 4000,
            },
            {
                text: '5,000',
                value: 5000,
            },
            {
                text: '7,500',
                value: 7500,
            },
        ];
        const yearBuiltData = [
            {
                text: '2023',
                value: 2023,
            },
            {
                text: '2022',
                value: 2022,
            },
            {
                text: '2021',
                value: 2021,
            },
            {
                text: '2020',
                value: 2020,
            },
            {
                text: '2019',
                value: 2019,
            },
            {
                text: '2018',
                value: 2018,
            },
            {
                text: '2017',
                value: 2017,
            },
            {
                text: '2016',
                value: 2016,
            },
            {
                text: '2015',
                value: 2015,
            },
            {
                text: '2014',
                value: 2014,
            },
            {
                text: '2013',
                value: 2013,
            },
            {
                text: '2012',
                value: 2012,
            },
            {
                text: '2011',
                value: 2011,
            },
            {
                text: '2010',
                value: 2010,
            },
            {
                text: '2009',
                value: 2009,
            },
            {
                text: '2008',
                value: 2008,
            },
            {
                text: '2007',
                value: 2007,
            },
            {
                text: '2006',
                value: 2006,
            },
            {
                text: '2005',
                value: 2005,
            },
            {
                text: '2000',
                value: 2000,
            },
            {
                text: '1995',
                value: 1995,
            },
            {
                text: '1990',
                value: 1990,
            },
            {
                text: '1980',
                value: 1980,
            },
            {
                text: '1970',
                value: 1970,
            },
            {
                text: '1960',
                value: 1960,
            },
            {
                text: '1950',
                value: 1950,
            },
            {
                text: '1940',
                value: 1940,
            },
            {
                text: '1930',
                value: 1930,
            },
            {
                text: '1920',
                value: 1920,
            },
            {
                text: '1910',
                value: 1910,
            },
            {
                text: '1900',
                value: 1900,
            },
        ];
        //sort yearBuiltData by value
        yearBuiltData.sort((a, b) => {
            return a.value - b.value;
        });
        const daysText = this.molang('search.moreFilter.day', { pluralCount: 2 });
        const domData = [
            {
                text: `1 ${this.molang('search.moreFilter.day', { pluralCount: 1 })}`,
                value: 1,
            },
            {
                text: `3 ${daysText}`,
                value: 3,
            },
            {
                text: `7 ${daysText}`,
                value: 7,
            },
            {
                text: `14 ${daysText}`,
                value: 14,
            },
            {
                text: `30 ${daysText}`,
                value: 30,
            },
            {
                text: `45 ${daysText}`,
                value: 45,
            },
            {
                text: `60 ${daysText}`,
                value: 60,
            },
            {
                text: `90 ${daysText}`,
                value: 90,
            },
            {
                text: `180 ${daysText}`,
                value: 180,
            },
        ];
        const hoaData = [5, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 600, 700, 800, 900, 1000, 1250, 1500, 1750, 2000, 2500, 3000].map((item) => {
            return {
                text: `$${item}`,
                value: item,
            };
        });
        const fixedTags = [
            {
                title: 'Interior',
                tags: ['open_floor_plan', 'natural_light', 'tall_ceilings', 'hardwood_floors', 'living_room', 'dining_room', 'family_room', 'office', 'walk_in_closet', 'fireplace'],
            },
            {
                title: 'Kitchen',
                tags: ['stone_countertop', 'granite_countertops', 'quartz_countertops', 'kitchen_island', 'gas_range', 'double_oven', 'stainless_steel_appliances'],
            },
            {
                title: 'Exterior',
                tags: ['carport', 'rv_parking', 'single_level', 'pool', 'hot_tub', 'backyard', 'patio', 'porch', 'deck', 'horse_property'],
            },
            {
                title: 'Lot',
                tags: ['waterfront', 'corner_lot', 'cul_de_sac', 'golf_course_frontage'],
            },
            {
                title: 'Views',
                tags: ['water_view', 'mountain_views', 'skyline_view', 'panoramic_views'],
            },
            {
                title: 'Community Amenities',
                tags: ['community_pool', 'boat-friendly', 'golf_course_community', 'tennis_courts', 'clubhouse'],
            },
        ];
        const bathsText = this.molang('search.filter.anyBaths'),
            bedsText = this.molang('search.filter.anyBeds');
        const filterData = {
            bathroomData: [
                {
                    text: this.molang('search.common.any'),
                    labelText: bathsText,
                    value: 0,
                },
                {
                    text: '1',
                    labelText: `1 ${bathsText}`,
                    value: 1,
                },
                {
                    text: '2',
                    labelText: `2 ${bathsText}`,
                    value: 2,
                },
                {
                    text: '3',
                    labelText: `3 ${bathsText}`,
                    value: 3,
                },
                {
                    text: '4',
                    labelText: `4 ${bathsText}`,
                    value: 4,
                },
                {
                    text: '5+',
                    labelText: `5+ ${bathsText}`,
                    value: 5,
                },
            ],
            bedroomData: [
                {
                    text: this.molang('search.common.any'),
                    labelText: bedsText,
                    value: 0,
                },
                {
                    text: '1',
                    labelText: `1 ${bedsText}`,
                    value: 1,
                },
                {
                    text: '2',
                    labelText: `2+ ${bedsText}`,
                    value: 2,
                },
                {
                    text: '3',
                    labelText: `3+ ${bedsText}`,
                    value: 3,
                },
                {
                    text: '4',
                    labelText: `4+ ${bedsText}`,
                    value: 4,
                },
                {
                    text: '5+',
                    labelText: `5+ ${bedsText}`,
                    value: 5,
                },
            ],
            soldData: [
                {
                    text: this.molang('search.moreFilter.all'),
                    labelText: this.molang('search.moreFilter.soldLabel.all'),
                    value: 'all',
                },
                {
                    text: this.molang('search.moreFilter.last1Week'),
                    labelText: this.molang('search.moreFilter.soldLabel.7d'),
                    value: '7d',
                },
                {
                    text: this.molang('search.moreFilter.last1Month'),
                    labelText: this.molang('search.moreFilter.soldLabel.1m'),
                    value: '1m',
                },
                {
                    text: this.molang('search.moreFilter.last3Months'),
                    labelText: this.molang('search.moreFilter.soldLabel.3m'),
                    value: '3m',
                },
                {
                    text: this.molang('search.moreFilter.last6Months'),
                    labelText: this.molang('search.moreFilter.soldLabel.6m'),
                    value: '6m',
                },
                {
                    text: this.molang('search.moreFilter.last1Year'),
                    labelText: this.molang('search.moreFilter.soldLabel.1y'),
                    value: '1y',
                },
                {
                    text: this.molang('search.moreFilter.last2Years'),
                    labelText: this.molang('search.moreFilter.soldLabel.2y'),
                    value: '2y',
                },
            ],
            propertyTypeData: [
                {
                    text: `<i class="icon-property-single-family"></i> ${this.molang('search.moreFilter.houses')}`,
                    value: 'single-family',
                },
                {
                    text: `<i class="icon-property-condo"></i> ${this.molang('search.moreFilter.condo')}`,
                    value: 'condos',
                    tag: 'condos',
                },
                {
                    text: `<i class="icon-property-condo"></i> ${this.molang('search.moreFilter.apartments')}`,
                    value: 'condos',
                    displayValue: 'apartment',
                },
                {
                    text: `<i class="icon-property-multi-family"></i> ${this.molang('search.moreFilter.multiFamily')}`,
                    value: 'multi-family',
                },
                {
                    text: `<i class="icon-property-lot"></i> ${this.molang('search.moreFilter.lotLand')}`,
                    value: 'land',
                },

                {
                    text: `<i class="icon-property-mobile"></i> ${this.molang('search.moreFilter.mobile')}`,
                    value: 'mobile',
                },
                {
                    text: `<i class="icon-property-other"></i> ${this.molang('search.moreFilter.other')}`,
                    value: 'other',
                },
            ],
            propertyStatesData: [
                {
                    text: `<i class="hidden-xs icon-eye-slash"></i> ${this.molang('search.moreFilter.hidePending')}`,
                    value: 'hidePending',
                    disabled: false,
                },
                {
                    text: `<i class="hidden-xs icon-year-built"></i> ${this.molang('search.moreFilter.newConstruction')}`,
                    value: 'newConstruction',
                    disabled: false,
                },
                {
                    text: this.molang('search.moreFilter.newInLast7Days'),
                    value: 'newest',
                    disabled: false,
                },
                {
                    text: this.molang('search.moreFilter.priceReduced'),
                    value: 'priceReduced',
                    disabled: false,
                },
                {
                    text: this.molang('search.moreFilter.foreclosed'),
                    value: 'foreclosed',
                    disabled: false,
                },
            ],
            mediaData: [
                {
                    text: this.molang('search.moreFilter.mustHavePhotos'),
                    value: 'photos',
                    disabled: false,
                },
                {
                    text: this.molang('search.moreFilter.openHouses'),
                    value: 'openHouse',
                    disabled: false,
                },
                {
                    text: this.molang('search.moreFilter.virtualTour'),
                    value: 'virtualTour',
                    disabled: false,
                },
            ],
            sqrtFeetData: sqrtFeetData,
            lotSizeData: lotSizeData,
            yearBuiltData: yearBuiltData,
            domData: domData,
            hoaData: hoaData,
        };

        return {
            focusIds: [],
            wideCase: ['tagFilter'],
            wide: false,
            componentMounted: false,
            isActive: false,
            fixedTags: fixedTags,
            filterData: filterData,
            searchFilterData: [
                {
                    id: 'price',
                    order: 1,
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: [],
                    model: 'price',
                    label: (value, defaultValue, changed, obj) => {
                        let label = '';
                        if (changed) {
                            let min = value[0] * 1 || 0;
                            let max = value[1] * 1 || 0;
                            if (min > 0 && !max) {
                                label = `${format.friendlyPrice(min)}+`;
                            } else if (!min && max > 0) {
                                label = `$0 - $${format.friendlyPrice(max)}`;
                            } else {
                                label = `$${format.friendlyPrice(min)} - $${format.friendlyPrice(max)}`;
                            }
                        } else {
                            label = this.molang('search.filter.price');
                        }
                        return this.getIconLabel(label, changed, obj.icon);
                    },
                    title: this.molang('search.filter.price'),
                    icon: 'icon-price-tag',
                    options: {
                        mapping: {
                            min: 'minPrice',
                            max: 'maxPrice',
                        },
                        input: 'mvtInputCurrency',
                        defaultValue: [0, 0],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                    },
                },
                {
                    id: 'propertyType',
                    disabled: false,
                    type: 'mvtCheckbox',
                    theme: 'grid xs-grid-cols-2 buttons',
                    data: filterData.propertyTypeData,
                    model: 'propertyType',
                    title: this.molang('search.moreFilter.type'),
                    icon: 'icon-property-single-family',
                    order: 1,
                    label: (value, defaultValue, changed, obj) => {
                        if (!changed) {
                            return this.getIconLabel(this.molang('search.moreFilter.type'), changed, obj.icon);
                        }
                        let propertyDataset = {
                            'single-family': this.molang('search.moreFilter.chip.house'),
                            condos: this.glb.rentals
                                ? this.molang('search.moreFilter.chip.apartment')
                                : this.molang('search.moreFilter.chip.condo'),
                            'multi-family': this.molang('search.moreFilter.chip.multi'),
                            land: this.molang('search.moreFilter.chip.land'),
                            mobile: this.molang('search.moreFilter.chip.mobile'),
                            other: this.molang('search.moreFilter.chip.other'),
                        };

                        const label = value.map((item) => {
                            return propertyDataset[item];
                        }).join(', ');
                        return `<span title="${label}">${label}</span>`;
                    },
                },
                {
                    id: 'bed',
                    order: 1,
                    disabled: false,
                    type: 'mvtRange',
                    data: filterData.bedroomData,
                    model: 'bed',
                    label: this.molang('search.filter.anyBeds'),
                    title: this.molang('search.filter.anyBeds'),
                    icon: 'icon-bed',
                    subTitle: this.molang('search.filter.rangeHint'),
                    options: {
                        defaultValue: [0, 0],
                    },
                },
                {
                    id: 'bath',
                    order: 1,
                    merge: 'bed',
                    disabled: false,
                    type: 'mvtRange',
                    data: filterData.bathroomData,
                    model: 'bath',
                    label: this.molang('search.filter.anyBaths'),
                    title: this.molang('search.filter.anyBaths'),
                    icon: 'icon-bath',
                    options: {
                        defaultValue: [0, 0],
                    },
                },
                {
                    id: 'houseStates',
                    theme: 'grid xs-grid-cols-1 sm-grid-cols-2',
                    disabled: false,
                    type: 'mvtCheckbox',
                    data: filterData.propertyStatesData,
                    expose: true,
                    exposeItem: (value, defaultValue, changed, obj, filter) => {
                        return {
                            hide: false,
                            id: `houseStates-rentals`,
                            changed: filter.rentals,
                            label: this.molang('search.filter.tabs.forRent'),
                        };
                    },
                    model: 'houseStates',
                    label: this.molang('search.moreFilter.propertyStatus'),
                    title: this.molang('search.moreFilter.propertyStatus'),
                },
                {
                    id: 'soldDateRange',
                    theme: 'grid xs-grid-cols-2',
                    disabled: false,
                    type: 'mvtRadio',
                    data: filterData.soldData,
                    model: 'soldDateRange',
                    label: this.molang('search.filter.tabs.sold'),
                    title: this.molang('search.moreFilter.soldInLast'),
                    options: {
                        defaultValue: 0,
                        deselect: true,
                    },
                },
                {
                    id: 'houseMedia',
                    theme: 'grid xs-grid-cols-1 sm-grid-cols-2',
                    disabled: false,
                    type: 'mvtCheckbox',
                    data: filterData.mediaData,
                    model: 'houseStates',
                    expose: true,
                    label: this.molang('search.moreFilter.photosAndTours'),
                    title: this.molang('search.moreFilter.photosAndTours'),
                },
                {
                    id: 'tagFilter',
                    theme: '',
                    disabled: false,
                    order: 1,
                    type: 'mvtAutocompleteTag',
                    model: 'ojoAttribute',
                    label: (value, defaultValue, changed, obj) => {
                        let label = this.molang('search.filter.keywords');
                        if (changed && Array.isArray(value) && value.length > 0) {
                            label = `${label} <i class="filter-count">${value.length}</i>`;
                        }
                        return this.getIconLabel(label, changed, obj.icon);
                    },
                    title: this.molang('search.filter.keywords'),
                    icon: 'icon-insight',
                    options: {
                        fixedTags: ['pool', 'garage'],
                        placeholder: this.molang('search.filter.keywordsPlaceholder'),
                    },
                },
                {
                    id: 'lotSize',
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: filterData.lotSizeData,
                    model: 'lotSize',
                    label: this.molang('search.moreFilter.lotSize'),
                    title: this.molang('search.moreFilter.lotSize'),
                    options: {
                        mapping: {
                            min: 'minLotSize',
                            max: 'maxLotSize',
                        },
                        input: 'mvtInputSqft',
                        defaultValue: [0, 0],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                        readonly: true,
                    },
                },
                {
                    id: 'houseSize',
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: filterData.sqrtFeetData,
                    model: 'houseSize',
                    label: this.molang('search.filter.homeSize'),
                    title: this.molang('search.filter.homeSize'),
                    options: {
                        mapping: {
                            min: 'minHouseSize',
                            max: 'maxHouseSize',
                        },
                        input: 'mvtInputSqft',
                        defaultValue: [0, 0],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                    },
                },
                {
                    id: 'hoa',
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: filterData.hoaData,
                    model: 'hoa',
                    label: this.molang('search.moreFilter.hoaFees'),
                    title: this.molang('search.moreFilter.hoaFees'),
                    options: {
                        mapping: {
                            min: 'minHoa',
                            max: 'maxHoa',
                        },
                        input: 'mvtInputCurrency',
                        extraData: {
                            text: this.molang('search.moreFilter.noHOAFee'),
                            value: [-1, 0],
                        },
                        defaultValue: [-1, -1],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                    },
                },
                {
                    id: 'yearBuild',
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: filterData.yearBuiltData,
                    model: 'yearBuild',
                    label: (value, defaultValue, changed, obj) => {
                        let label = '';
                        if (changed) {
                            let min = value[0] * 1 || 0;
                            let max = value[1] * 1 || 0;
                            if (min > 0 && !max) {
                                label = this.molang('search.moreFilter.builtAfter', { year: min });
                            } else if (!min && max > 0) {
                                label = this.molang('search.moreFilter.builtBefore', { year: max + 1 });
                            } else {
                                label = `${min} - ${max} ${obj.title}`;
                            }
                        } else {
                            label = obj.title;
                        }
                        return label;
                    },
                    title: this.molang('search.moreFilter.yearBuilt'),
                    options: {
                        mapping: {
                            min: 'minYearBuild',
                            max: 'maxYearBuild',
                        },
                        input: 'mvtInputInt',
                        defaultValue: [0, 0],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                    },
                },
                {
                    id: 'dom',
                    disabled: false,
                    type: 'mvtInputRange',
                    theme: '',
                    data: filterData.domData,
                    model: 'dom',
                    label: this.molang('search.moreFilter.daysOnMovoto'),
                    title: this.molang('search.moreFilter.daysOnMovoto'),
                    options: {
                        mapping: {
                            min: 'minDOM',
                            max: 'maxDOM',
                        },
                        input: 'mvtInputInt',
                        defaultValue: [0, 0],
                        showSlider: true,
                        placeholderMin: this.molang('search.common.noMin'),
                        placeholderMax: this.molang('search.common.noMax'),
                    },
                },
            ],
        };
    },
    props: {
        resultCount: {
            type: Number,
            default: 0,
        },
        modelValue: {
            type: Object,
            required: true,
        },
    },
    created(){
        // During SSR, `glb.filterLabel` may already be initialized from Vuex.
        // Avoid overwriting it with an empty list while `filterModel` hydrates on the client.
        if (!Array.isArray(this.glb.filterLabel) || this.glb.filterLabel.length === 0) {
            this.glb.filterLabel = this.filterLabel;
        }
    },
    mounted() {
        this.componentMounted = true;
        this.$eventBus.$on('eventbus-searchfilter-reset', this.reset);
        this.$eventBus.$on('eventbus-searchfilter-open', this.open);
        this.$eventBus.$on('eventbus-filterlist-close', this.close);
        this.$eventBus.$on('eventbus-searchfilter-toogle', this.toggle);
        this.updatePriceRange(this.isRent);
    },
    beforeUnmount() {
        this.$eventBus.$off('eventbus-searchfilter-open');
        this.$eventBus.$off('eventbus-filterlist-close');
        this.$eventBus.$off('eventbus-searchfilter-toogle');
    },
    watch: {
        filterLabel(newVal) {
            // Avoid clobbering SSR-initialized content with an empty list during hydration.
            // After the component mounts, allow syncing even when the label list becomes [] (e.g., reset/clear).
            if (!Array.isArray(newVal)) return;
            if (!this.componentMounted) {
                // During hydration, only sync when we have actual labels.
                // This prevents overwriting SSR chips with [] but still allows SSR -> CSR convergence.
                if (newVal.length > 0) {
                    this.glb.filterLabel = newVal;
                }
                return;
            }

            this.glb.filterLabel = newVal;
        },
    },
};
